import navigationRoutes from "./navigationRoutes";
import Home from "@/project/karuna/pages/public/Home";
import About from "@/project/karuna/pages/public/About";
import Programs from "@/project/karuna/pages/public/Programs";
import Contact from "@/project/karuna/pages/public/Contact";
import Donate from "@/project/karuna/pages/public/Donate";
import Dashboard from "@/project/karuna/pages/Dashboard";
import NotFound from "@/project/karuna/pages/NotFound";
import DemoLogin from "../pages/DemoLogin";

// Public routes (Unauthenticated)
const publicRoutes = [
  {
    path: navigationRoutes.HOME,
    element: Home,
    name: "Home",
  },
  {
    path: navigationRoutes.ABOUT,
    element: About,
    name: "About",
  },
  {
    path: navigationRoutes.PROGRAMS,
    element: Programs,
    name: "Programs",
  },
  {
    path: navigationRoutes.CONTACT,
    element: Contact,
    name: "Contact",
  },
  {
    path: navigationRoutes.DONATE,
    element: Donate,
    name: "Donate",
  },
  {
    path: navigationRoutes.DEMO_LOGIN,
    element: DemoLogin,
    name: "Demo Login",
  },
];

// Protected routes (Authenticated)
const protectedRoutes = [
  {
    path: navigationRoutes.DASHBOARD,
    element: Dashboard,
    name: "Dashboard",
  },
  {
    path: navigationRoutes.NOT_FOUND,
    element: NotFound,
    name: "Not Found",
  },
];

const routes = [
  { type: "public", routes: publicRoutes },
  { type: "auth", routes: protectedRoutes },
];

export default routes;
